var custom_products = []
var variant_products = []
var product_tags = []
const collection = collectionJSON
const limitprod = limit
collection.slice(limitprod).forEach(function (product) {
    var object = {}
    var prodtags = 'notCustomilyProduct'
    var variants = []
    var hasVariant = false
    var variantType = ''
    var productprice = parseFloat(product.price / 100).toFixed(2)
    var singleImageClass = 'single-image'
    object.available = product.variants[0].available
    object.id = product.id
    object.title = product.title
    object.url = `/products/${product.handle}`
    object.description = product.description.length > 20 ? product.description.substr(0, 20) + '...' : product.description
    object.image = product.featured_image
    object.originalImageHover = product.images[1]
    object.imagehover = product.images[1]
    object.currentvariantId = product.variants[0] 
    if(product.images[1]) {
        singleImageClass = ''
    }
    product.options.forEach(function(option) {
        if(option == 'Size') {
            variantType = option
            product.variants.sort().forEach(function(variant) {
                variants.push(variant)
            })
        }
    })
    product.tags.forEach(function(tag) {
        if(tag == 'product_customily') {
            prodtags = tag
            return false
        }
    })
    if(product.variants.length > 1 && variantType == 'Size') {
        hasVariant = true
    }
    object.price = `£${productprice} GBP`
    if(hasVariant) {
        object.price = `from £${parseFloat(product.variants[0].price / 100).toFixed(2)} GBP`
    }
    object.productVariantLength = product.variants.length
    object.productVariantLimit = prodtags == 'product_customily' ? 2 : 5
    object.variants = prodtags == 'product_customily' ? variants.slice(0, 2) : variants.slice(0, 5)
    object.tags = prodtags
    object.vendor = product.vendor
    object.hasVariant = hasVariant
    object.singleImageClass = singleImageClass
    custom_products.push(object)
})

var app = new Vue({
    delimiters: ['${', '}'],
    el: appID,
    data: {
        products: custom_products
    },
    methods: {
        toggleImage: function(s) {
            s.imagehover = s.imagehover
        },
        toggleImageHover: function (s) {
            s.imagehover = s.originalImageHover
        }
    }
})